import { render, staticRenderFns } from "./ChannelRuleList.vue?vue&type=template&id=5fa4dc88&scoped=true"
import script from "./ChannelRuleList.vue?vue&type=script&lang=js"
export * from "./ChannelRuleList.vue?vue&type=script&lang=js"
import style0 from "./ChannelRuleList.vue?vue&type=style&index=0&id=5fa4dc88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa4dc88",
  null
  
)

export default component.exports